import { useMemo } from 'react';
import { nodeTypeColors } from '../diagrams/node-types';
import { useI18n } from '../i18n/i18n';
import { type DiagramPreview, layoutThumbnail, THUMB } from './thumbnail-layout';

const PAD = 6;

/**
 * Мини-превью схемы на плашке: прямоугольники цветом типа и связи, своей раскладкой без
 * библиотеки схем. Пустая схема — подпись. Превью показывает только верхние уровни — сколько
 * прислал API.
 */
export function DiagramThumbnail({ preview }: { preview: DiagramPreview }) {
  const { t } = useI18n();
  const layout = useMemo(() => layoutThumbnail(preview), [preview]);
  if (preview.nodes.length === 0) {
    return (
      <div className="grid h-full place-items-center text-xs text-muted-foreground">
        {t('home.emptyDiagram')}
      </div>
    );
  }
  const width = layout.width + PAD * 2;
  const height = layout.height + PAD * 2;
  return (
    <svg
      viewBox={`${-PAD} ${-PAD} ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      className="h-full w-full"
      aria-hidden="true"
    >
      {preview.links.map(([source, target]) => {
        const from = source === undefined ? undefined : layout.positions[source];
        const to = target === undefined ? undefined : layout.positions[target];
        if (from === undefined || to === undefined) return null;
        return (
          <line
            key={`${source}-${target}`}
            x1={from.x + THUMB.W / 2}
            y1={from.y + THUMB.H}
            x2={to.x + THUMB.W / 2}
            y2={to.y}
            stroke="var(--thumb-link)"
            strokeWidth={1}
          />
        );
      })}
      {preview.nodes.map((node, index) => {
        const point = layout.positions[index];
        if (point === undefined) return null;
        const colors = nodeTypeColors(node.type);
        return (
          <rect
            key={index}
            x={point.x}
            y={point.y}
            width={THUMB.W}
            height={THUMB.H}
            rx={3}
            fill={colors.bg}
            stroke={colors.stroke}
            strokeWidth={1}
          />
        );
      })}
    </svg>
  );
}
